import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#164b93',
        secondary: '#e51a23',
        accent: '#40c1ac',
        error: '#fbbc0c',
        info: '#f2f4f5',
        success: '#40c1ac',
        warning: '#fbbc0c',
      },
    },
  },
})

/*
background-color: #164b93; // blue
background-color: #f2f4f5; // white
background-color: #e51a23; // red
    color: #40c1ac; // green light
    color: #0d337d; // dark blue
background-color: #373737; // dark gray
    color: #fbbc0c; // yellow
    color: #335a5e; // dark green




 */
